import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Auth, I18n } from 'aws-amplify'
import { useAlert } from 'react-alert'

import { settings } from '../../../../main/configs/settings'

import { useForm } from '../../../hooks'
import { exceptionsError, goToUrl, setUser } from '../../../utils'
import { Button, Input } from '../../../components'
import { CardContainer } from '../../../components/ui/components'

import { ArrowRightSvg, FullLogoSvg } from '../../../assets/icons/svgComponents'

import * as S from './styles'
import { fetchMe } from '../../../../main/usecases'

const ConfirmEmail = () => {
  const [loading, setLoading] = useState(false)
  const alert = useAlert()
  const history = useHistory()
  const state: any = history.location.state
  const stateEmail = state ? state.email : null
  const password = state ? state.password : null
  const code = useForm()

  const resendVerifyUserCode = async () => {
    try {
      await Auth.resendSignUp(stateEmail)
      alert.show(I18n.get('ResendSignUpSuccess'), {
        type: 'success',
        timeout: 4000
      })
    } catch (error: any) {
      alert.show(exceptionsError(error.code, error.message), {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      setLoading(true)

      // confirm email
      await Auth.confirmSignUp(stateEmail, code.value)

      alert.show(I18n.get('UserSuccessfullyVerified'), {
        type: 'success',
        timeout: 4000
      })

      // login
      await Auth.signIn(stateEmail, password)

      // fetch User
      const me = await fetchMe().load()

      // save user on localstorage
      await setUser(me)

      // redirect to home
      goToUrl(history, settings.dashboardRoute)
    } catch (error: any) {
      alert.show(exceptionsError(error.code, error.message), {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <S.Wrapper>
      <CardContainer style="container">
        <S.Content>
          <FullLogoSvg
            colorX="#00995D"
            colorLetters="#6F6F6E"
            width="182"
            height="42"
          />
          <S.Subtitle>Seja bem-vindo(a)!</S.Subtitle>
          <S.Description>Informe o código de verificação</S.Description>
          <form onSubmit={onSubmit}>
            <Input
              disabled
              labelColor="#4F4F4F"
              label="E-mail"
              type="email"
              name="email"
              value={stateEmail}
            />
            <Input
              labelColor="#4F4F4F"
              label="Código"
              type="number"
              name="code"
              {...code}
            />
            <S.ButtonContainer>
              <button
                className="resend-btn"
                type="button"
                onClick={resendVerifyUserCode}
              >
                Reenviar código
              </button>
              {loading ? (
                <Button
                  disabled
                  endIcon={<ArrowRightSvg className="icon-arrow-right" />}
                >
                  Confirmando...
                </Button>
              ) : (
                <Button
                  endIcon={<ArrowRightSvg className="icon-arrow-right" />}
                >
                  Confirmar
                </Button>
              )}
            </S.ButtonContainer>
          </form>
        </S.Content>
      </CardContainer>
    </S.Wrapper>
  )
}
export default ConfirmEmail
